import { render, staticRenderFns } from "./SLoading.vue?vue&type=template&id=506fbffd&scoped=true&"
import script from "./SLoading.vue?vue&type=script&lang=js&"
export * from "./SLoading.vue?vue&type=script&lang=js&"
import style0 from "./SLoading.vue?vue&type=style&index=0&id=506fbffd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fbffd",
  null
  
)

export default component.exports